"use strict";
/*
* Created on 16.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var BigNumberGreaterThanValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberGreaterThanValidator");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var MultiBuyVariantEnum_1 = require("./MultiBuyVariantEnum");

var PosTypeEnum_1 = require("./PosTypeEnum");
/**
 * @author ZSr
 */


var WindowItemPosAttributes =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemPosAttributes, _DomainObject_1$Domai);

  /**
   * @param posActionFlag - flag represent that on this product will be a POS action
   * @param posMechanics - text field for the description of the POS action
   * @param posType - based on the type there are other attributes
   * @param posMultiBuyVariant - if posType is MultiBuy, select one of these
   * @param posDiscountPerPiece
   * @param posGiftId - internal product id
   * @param posGiftPrice - regular price for posGift product
   * @param posGiftPreviousPrice - regular previous price for posGift product
   * @param posGiftForecast - expected volume of GIFT which will be selling.
   * @param posGiftDistrModelId - options delivery for gift (values in codebook distribution model)
   * @param posDistributionModelDays - number of days for certain distribution model options - user input
   * @param posMarginImpactTheoretical - number field. For the POS types Multibuy,
   * Multibuy better price and GIFT is this field automatically calculated.
   * The number is all the times negative. When the POS type is Other
   * has to be this field entered manually as a positive or negative number and system automatically fill
   * the negative mark and the number will be negative all the time
   * @param posMarginImpactExpected - field with negative value.
   * The field is not possible change and it is calculated based on the numbers from POS Margin impact theoretical and POS Redemption.
   * @param posRedemption - mandatory number field with percentage value. Default value is 100%.
   * Based on this number the field POS Margin impact expected is calculated
   */
  function WindowItemPosAttributes(posActionFlag) {
    var _this;

    var posMechanics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var posType = arguments.length > 2 ? arguments[2] : undefined;
    var posMultiBuyVariant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var posDiscountPerPiece = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var posGiftId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var posGiftPrice = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var posGiftPreviousPrice = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var posGiftForecast = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var posGiftDistrModelId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
    var posDistributionModelDays = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
    var posMarginImpactTheoretical = arguments.length > 11 ? arguments[11] : undefined;
    var posMarginImpactExpected = arguments.length > 12 ? arguments[12] : undefined;
    var posRedemption = arguments.length > 13 ? arguments[13] : undefined;

    _classCallCheck(this, WindowItemPosAttributes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPosAttributes).call(this));
    _this.posActionFlag = posActionFlag;
    _this.posMechanics = posMechanics;
    _this.posType = posType;
    _this.posMultiBuyVariant = posMultiBuyVariant;
    _this.posDiscountPerPiece = posDiscountPerPiece;
    _this.posGiftId = posGiftId;
    _this.posGiftPrice = posGiftPrice;
    _this.posGiftPreviousPrice = posGiftPreviousPrice;
    _this.posGiftForecast = posGiftForecast;
    _this.posGiftDistrModelId = posGiftDistrModelId;
    _this.posDistributionModelDays = posDistributionModelDays;
    _this.posMarginImpactTheoretical = posMarginImpactTheoretical;
    _this.posMarginImpactExpected = posMarginImpactExpected;
    _this.posRedemption = posRedemption;
    return _this;
  }

  _createClass(WindowItemPosAttributes, [{
    key: "calcMarginExpected",

    /**
     * Calculates posMarginImpactExpected for {@link WindowItemPosAttributes}
     *
     * @returns {@link WindowItemPosAttributes}
     */
    value: function calcMarginExpected() {
      return this.copy('posMarginImpactExpected', WindowItemPosAttributes.calcMarginExpected(this.posMarginImpactTheoretical, this.posRedemption));
    }
  }], [{
    key: "empty",
    value: function empty() {
      return new WindowItemPosAttributes(false, null, PosTypeEnum_1.PosTypeEnum.None, null, null, null, null, null, null, null, null, big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0), big_decimal_1.bigdecimal(0));
    }
  }, {
    key: "parseMultiBuyVariant",
    value: function parseMultiBuyVariant(variant) {
      var split = variant.split('+');

      if (split.length !== 2) {
        console.log("MultiBuyVariantEnum wrongValue ".concat(variant));
        return [1, 1];
      }

      return [parseInt(split[0], 10), parseInt(split[1], 10)];
    }
  }, {
    key: "fromMat",
    value: function fromMat(mat) {
      return new WindowItemPosAttributes(mat.posActionFlag, mat.posMechanics, mat.posType, mat.posMultiBuyVariant, mat.posDiscountPerPiece, mat.posGiftId, mat.posGiftPrice, mat.posGiftPreviousPrice, mat.posGiftForecast, mat.posGiftDistrModelId, mat.posDistributionModelDays, mat.posMarginImpactTheoretical, mat.posMarginImpactExpected, mat.posRedemption);
    }
    /**
     * Calculates posMarginImpactExpected for {@link WindowItemPosAttributes}
     *
     * @param impactTheoretical
     * @param redemption
     * @returns {@link BigDecimal}
     */

  }, {
    key: "calcMarginExpected",
    value: function calcMarginExpected(impactTheoretical, redemption) {
      return impactTheoretical.times(redemption);
    }
  }]);

  return WindowItemPosAttributes;
}(DomainObject_1.DomainObject);

exports.WindowItemPosAttributes = WindowItemPosAttributes;

WindowItemPosAttributes.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemPosAttributes.name);
  return {
    posActionFlag: builder.bool('posActionFlag'),
    posMechanics: builder.opt(builder.str('posMechanics', new StringLengthValidator_1.StringLengthValidator(1, 20))),
    posType: builder.senum('posType', PosTypeEnum_1.PosTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.PosType),
    posMultiBuyVariant: builder.opt(builder.senum('posMultiBuyVariant', MultiBuyVariantEnum_1.MultiBuyVariantEnum, CodebookLookupSequence_1.CodebookLookupSequence.MultiBuyVariant)),
    posDiscountPerPiece: builder.opt(builder.bigNum('posDiscountPerPiece', new BigNumberGreaterThanValidator_1.BigNumberGreaterThanValidator(big_decimal_1.bigdecimal(0), true))),
    posGiftId: builder.opt(builder.str('posGiftId')),
    posGiftPrice: builder.opt(builder.bigNum('posGiftPrice')),
    posGiftPreviousPrice: builder.opt(builder.bigNum('posGiftPreviousPrice')),
    posGiftForecast: builder.opt(builder.bigNum('posGiftForecast')),
    posGiftDistrModelId: builder.opt(builder.lookup('posGiftDistrModelId', CodebookLookupSequence_1.CodebookLookupSequence.DistributionModel)),
    posDistributionModelDays: builder.opt(builder.num('posDistributionModelDays')),
    posMarginImpactTheoretical: builder.bigNum('posMarginImpactTheoretical'),
    posMarginImpactExpected: builder.bigNum('posMarginImpactExpected'),
    posRedemption: builder.bigNum('posRedemption')
  };
}();